import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { Input } from '../index';

import './index.scss';

const MutateCheckbox = ({ name, header, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <div className="mutate-checkbox">
      {header && <label htmlFor={`${name}-input`}>{header}</label>}
      <Input
        {...props}
        {...field}
        className={classNames(
          'mutate-checkbox',
          { 'mutate-checkbox-error': fieldMeta.error },
          // eslint-disable-next-line react/destructuring-assignment
          props.className,
        )}
        id={`${name}-input`}
        checked={field.value || false}
        type="checkbox"
      />
    </div>
  );
};

export default MutateCheckbox;
